/**
 * Przełączniki funkcji karty pojazdu i floty (decyzja użytkownika
 * 12.10.2026: „obecna” = produkcja 0.31.3, zmiany z develop za
 * przełącznikami). Klucze to dane — te same co w API
 * (`apps/api/src/feature-flags/feature-flags.ts`, blok B) — nie
 * przemianowujemy ich.
 *
 * Wyłączony przełącznik = ekran jak na produkcji 0.31.3; reguły po stronie
 * API (trasy 404, odpowiedzi bez nowych pól) pilnuje API, ekran tylko
 * wybiera, co pokazać (`useFeature`, `FeatureGate`).
 */

/** Karta pojazdu wg prototypu p. Mariusza (0.31.5) i kolory prototypu w harmonogramie floty. */
export const VEHICLE_CARD_PROTOTYPE = 'vehicleCardPrototype';

/** Flota bez pojazdów archiwalnych, przełącznik „Pokaż także archiwalne” (0.31.4). */
export const FLEET_HIDE_ARCHIVED = 'fleetHideArchived';

/** „W eksploatacji” zamiast „Sprawne” (decyzja 08.10.2026). */
export const OPERATIONAL_LABEL = 'operationalLabel';

/** Sekcja „Historia zmian z TMS” na karcie pojazdu (12.10.2026). */
export const CAR_CHANGE_HISTORY = 'carChangeHistory';

/**
 * Wiersz „Nr terminala Trimble” w kartotece karty pojazdu (21.10.2026,
 * S-21.10-27; pytanie 46: „telefon kierowcy” w TMS to numer terminala
 * Trimble) — przełącznik fali C.
 */
export const TRIMBLE_TERMINAL_ON_CARD = 'trimbleTerminalOnCard';

/** „Zajęte do” wg planu TMS na harmonogramie (12.10.2026). */
export const OCCUPIED_UNTIL_TMS_PLAN = 'occupiedUntilTmsPlan';

// --- Etap 1 makiety FTL: harmonogram floty (15.10.2026) ---

/** Harmonogram floty wg makiety FTL p. Mariusza, pkt 9.1 (Etap 1). */
export const FLEET_SCHEDULE_MOCKUP = 'fleetScheduleMockup';

/** Kolumna „Pasujące” i liczby w lukach — liczone w tle (Etap 1). */
export const FLEET_MATCHING_ORDERS = 'fleetMatchingOrders';

/**
 * ADR wpisywany ręcznie — przełącznik obszaru E („kierowcy, konto i inne”);
 * pole „ADR” stoi na karcie pojazdu, więc karta go czyta.
 */
export const MANUAL_ADR = 'manualAdr';

// --- Etap 1 makiety FTL: karta i harmonogram pojazdu (15.10.2026) ---
// Działają tylko na karcie wg prototypu (`vehicleCardPrototype`).

/** Osobny wiersz „Warianty” na osi i „3 dni” w skali (makieta); start dalej od 14 dni (wzorzec). */
export const VEHICLE_VARIANTS_LANE = 'vehicleVariantsLane';

/** Podgląd rekomendowanego zlecenia na osi z odcinkami (`GET /car-schedules/preview`). */
export const VEHICLE_PREVIEW_SEGMENTS = 'vehiclePreviewSegments';

/** Historia pojazdu z dzienników zleceń (`GET /car-schedules/history`). */
export const VEHICLE_ASSIGNMENT_HISTORY = 'vehicleAssignmentHistory';

/** Panel „Do zrobienia” na karcie pojazdu. */
export const VEHICLE_TODO_PANEL = 'vehicleTodoPanel';

// --- Decyzje 22.10.2026: korekty kartotek pojazdów ---

/**
 * Korekty kartoteki pojazdu: kierowca, naczepa, terminy uprawnień
 * (S-22.10-03, `CarCorrections.tsx`).
 */
export const FLEET_CORRECTIONS = 'fleetCorrections';

// --- Prace 24.10.2026: G2 harmonogramy (Gantt) ---

/** Okna klienta jako nawiasy Z/R na wykresach FTL (S-24.10-05, `bracketRules.ts`). */
export const GANTT_WINDOW_BRACKETS = 'ganttWindowBrackets';

/** Zlecenie w realizacji w TMS nie jest wariantem (S-24.10-06, `planRows.runningInTms`). */
export const RUNNING_ORDER_NOT_VARIANT = 'runningOrderNotVariant';
